const reports = [
  {
    path: '/reports/payments',
    name: 'report-payments',
    component: () => import('@/views/reports/PaymentsReport.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_payament_count_report',
      resource: 'all',
    },
  },
  {
    path: '/reports/users',
    name: 'report-users',
    component: () => import('@/views/reports/UsersReport.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_user_count_report',
      resource: 'all',
    },
  },
  {
    path: '/reports/deliveries',
    name: 'report-deliveries',
    component: () => import('@/views/reports/DeliveriesReport.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_deliver_time_report',
      resource: 'all',
    },
  },
  {
    path: '/reports/support',
    name: 'report-support',
    component: () => import('@/views/reports/SupportReport.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_support_activity_report',
      resource: 'all',
    },
  },
  {
    path: '/reports/yearly',
    name: 'report-yearly',
    component: () => import('@/views/reports/YearlyReport.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_yearly_report',
      resource: 'all',
    },
  },
  {
    path: '/reports/tickets',
    name: 'report-tickets',
    component: () => import('@/views/reports/TicketReport.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_ticket_report',
      resource: 'all',
    },
  },
  {
    path: '/reports/calss',
    name: 'report-calls',
    component: () => import('@/views/reports/CallReport.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_call_report',
      resource: 'all',
    },
  },
]

export default reports
